import React, { useCallback } from "react";
import { useStore } from "../../store/store";
import { useRequiredMsgs } from "../../store/requiredMsgs";
import { stops } from "./defaults";

function useStopsSelector() {
  const addToQuote = useStore((state) => state.addToQuote);
  const doorType = useStore((state) => state.quote.doorType);
  const material = useStore((state) => state.quote.material);
  const stickingStops = useStore((state) => state.quote.stickingStops); //clad
  const stopsInterior = useStore((state) => state.quote.stickingStopsInterior); //wood
  const stopsExterior = useStore((state) => state.quote.stickingStopsExterior); //wood
  const stilesAndRails = useStore((state) => state.quote.stilesAndRails); //clad
  const findRequired = useRequiredMsgs((state) => state.findRequired);
  const removeRequired = useRequiredMsgs((state) => state.removeRequired);
  const isPico = stilesAndRails?.includes("Pico");
  const isPicoBifold = isPico && doorType === "Bi-fold";
  const isAlum = material === "All Aluminum";
  const stilesRailsProfile = useStore(
    (state) => state.quote.stilesRailsProfile,
  );
  const cladStopsOptions = isPico
    ? stops.filter((itm) => itm.label !== "Ovolo")
    : stops;

  const handleClickStop = useCallback(
    (label: string) => {
      const checked = label === stickingStops;

      if (isAlum && stilesRailsProfile === "Square") return;

      if (checked) {
        addToQuote({ stickingStops: "" }, "stickingStops");
      } else {
        if (findRequired("Stickings and Stops Profile")) {
          removeRequired("Stickings and Stops Profile");
        }

        addToQuote({ stickingStops: label });
      }
    },
    [stickingStops, stilesRailsProfile],
  );

  const handleClickExt = useCallback(
    (label: string) => {
      const checked = label === stopsExterior;

      if (checked) {
        addToQuote({ stickingStopsExterior: "" }, "stickingStopsExterior");
      } else {
        if (findRequired("Exterior Stop Profile"))
          removeRequired("Exterior Stop Profile");
        addToQuote({ stickingStopsExterior: label });
      }
    },
    [stopsExterior],
  );

  const handleClickInt = useCallback(
    (label: string) => {
      const checked = label === stopsInterior;

      if (checked) {
        addToQuote({ stickingStopsInterior: "" }, "stickingStopsInterior");
      } else {
        if (findRequired("Interior Stop Profile"))
          removeRequired("Interior Stop Profile");
        addToQuote({ stickingStopsInterior: label });
      }
    },
    [stopsInterior],
  );

  return {
    handleClickExt,
    handleClickInt,
    handleClickStop,
    material,
    stopsInterior,
    stopsExterior,
    stickingStops,
    stilesAndRails,
    isAlum,
    stilesRailsProfile,
    isPicoBifold,
    cladStopsOptions,
  };
}

export default useStopsSelector;
